module.exports = __webpack_public_path__ + "front/img/tab-bg.4f185d1d.png";